import React from 'react';
import { Box, ButtonBase, Grid, Typography } from '@mui/material';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';

export default function StepDataSource({ datasets = [], selectedId, onSelect, sx }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
        {ANALYTICS_COPY.stepDataSource}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
        {ANALYTICS_COPY.stepDataSourceHint}
      </Typography>
      <Grid container spacing={2}>
        {datasets.map((dataset) => {
          const selected = selectedId === dataset.id;
          return (
            <Grid item xs={12} sm={6} md={4} key={dataset.id}>
              <ButtonBase
                onClick={() => onSelect(dataset.id)}
                aria-pressed={selected}
                sx={{
                  ...sx?.datasetCard,
                  ...(selected ? sx?.datasetCardSelected : {}),
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                }}
              >
                <Typography variant="subtitle1" fontWeight={600}>
                  {dataset.label}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                  {dataset.description}
                </Typography>
              </ButtonBase>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
